<template>
     <div id="echart-barCir" :style="{ height: '100%',width:'100%'}"></div>   
</template>

<script>
export default({
    methods: {
      initData() {
      },
      initChart() {  
        this.barCirChart = this.echarts.init(document.getElementById("echart-barCir"));
        const option = {
            legend: { 
                orient: 'vertical',
                right: 5,
                top: 'center'
            },
            title: {
                text: 'Disease and RNA type composition of gene data',
                top: "0%",
                left: "center",
                textStyle: {
                  "fontSize": 14
                }
            },
            grid:{
              top:'10%'
            },
            radiusAxis: {
              type: 'category',
              // data: ['lncRNA','miRNA','snoRNA','circRNA','scaRNA','misc_RNA','snRNA'],
              data:['Anxiety disorder','Bipolar disorder','Major depressive disorder','Schizophrenia'],
              z: 10,
              axisLabel: {
                interval: 0,
                formatter:function (value, index) {
                  if(value=='Anxiety disorder'){
                    return 'AX'
                  }else if(value=='Bipolar disorder'){
                    return 'BD'
                  }else if(value=='Major depressive disorder'){
                    return 'MDD'
                  }else if(value=='Schizophrenia'){
                    return 'SZ'
                  }
                }
              },
            },
            tooltip: {
              trigger: 'axis',
              position: ['50%', '50%']
            },
            polar: {
              radius:'63%',
            },
            angleAxis: {},
            series: [{
              type: 'bar',
              data: [0,14,0,42],
              coordinateSystem: 'polar',
              name: 'snoRNA',
              stack: 'a',
              emphasis: {
                focus: 'series'
              }
            },{
              type: 'bar',
              data: [0,1,0,0],
              coordinateSystem: 'polar',
              name: 'scaRNA',
              stack: 'a',
              emphasis: {
                focus: 'series'
              }
            },{
              type: 'bar',
              data: [0,11,25,9],
              coordinateSystem: 'polar',
              name: 'circRNA',
              stack: 'a',
              emphasis: {
                focus: 'series'
              }
            },{
              type: 'bar',
              data: [0,0,0,3],
              coordinateSystem: 'polar',
              name: 'snRNA',
              stack: 'a',
              emphasis: {
                focus: 'series'
              }
            },{
              type: 'bar',
              data: [27,118,274,220],
              coordinateSystem: 'polar',
              name: 'miRNA',
              stack: 'a',
              emphasis: {
                focus: 'series'
              }
            },{
              type: 'bar',
              data: [8,914,70,388],
              coordinateSystem: 'polar',
              name: 'lncRNA',
              stack: 'a',
              emphasis: {
                focus: 'series'
              }
            }]
        };
        this.barCirChart.setOption(option);
        window.addEventListener("resize", () => {
          this.barCirChart.resize();
        });
      },
    }
})


</script>